import styled from 'styled-components';

export const Title = styled.h1`
  margin: 0 0 34px 0;
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: normal;
  color: ${({ theme }) => theme.colors.limedSpruce};

  .header {
    display: block;
    letter-spacing: -0.5px;
    margin-bottom: 8px;
  }

  .description {
    display: block;
    font-size: ${({ theme }) => theme.fontSize.xn};
  }

  @media screen and (max-width: 1024px) {
    margin-bottom: 24px;
  }

  @media screen and (max-width: 512px) {
    padding: 10px;
    margin-bottom: 8px;
    font-size: ${({ theme }) => theme.fontSize.lg};

    .description {
      font-size: ${({ theme }) => theme.fontSize.nm};
    }
  }
`;
